<template>
  <div class="header-container">
    <div
      class="header-container__header"
      :class="{
        '-background': ['result', 'register', 'completion'].includes(
          currentRoute
        ),
        '-hidden': ['loading'].includes(currentRoute)
      }"
    >
      <Header
        :title="introSettings.title"
        :mini="currentRoute !== 'home'"
        :expanded="
          [
            Routes.result.name,
            Routes.register.name,
            Routes.completion.name
          ].includes(currentRoute)
        "
      />
    </div>
    <div
      class="header-container__header"
      :class="{
        '-hidden': [
          Routes.home.name,
          Routes.quiz.name,
          Routes.loading.name
        ].includes(currentRoute)
      }"
    >
      <Header mini light />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { Routes } from "@/constants";

import Header from "@/components/Header";

export default {
  name: "HeaderContainer",
  components: {
    Header
  },
  data() {
    return {
      Routes: Routes
    };
  },
  computed: {
    currentRoute: function() {
      return this.$route.name;
    },
    ...mapState({
      introSettings: state => state.introSettings
    })
  }
};
</script>

<style lang="scss" scoped>
.header-container {
  display: block;

  &__header {
    $_transition-properties: transform, opacity;
    opacity: 1;
    position: fixed;
    transform: translateY(0);
    transition: cta-transition($_transition-properties, 1.3s);
    width: 100vw;
    z-index: z-index("header");

    &.-background {
      z-index: z-index("background");
    }

    &.-hidden {
      opacity: 0;
      transform: translateY(-250%);
    }
  }
}
</style>
